const INVALID_FILE_NAME_CHARS = /[\\/:*?"<>|\s]+/g;

export const toFileNameSegment = (value) =>
  String(value).trim().replace(INVALID_FILE_NAME_CHARS, '-');

export const downloadJson = (data, fileName) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
